import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import { App } from './App.tsx';
import { tema } from './app/tema.ts';
import { ApiError } from './shared/api/client.ts';
import { ProvedorSessao } from './features/auth/sessao.tsx';

const clienteDeConsultas = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Erro de regra de negócio não melhora com repetição; só vale repetir
      // falha de rede ou erro do servidor.
      retry: (tentativas, erro) => {
        if (erro instanceof ApiError && erro.status < 500) return false;
        return tentativas < 2;
      },
    },
  },
});

const raiz = document.getElementById('root');
if (raiz === null) {
  throw new Error('Elemento #root não encontrado no index.html.');
}

createRoot(raiz).render(
  <StrictMode>
    <ThemeProvider theme={tema} defaultMode="system">
      {/* Normaliza os estilos do navegador e aplica o fundo do tema. */}
      <CssBaseline />
      <QueryClientProvider client={clienteDeConsultas}>
        <BrowserRouter>
          {/* Dentro do QueryClientProvider: a sessão limpa o cache ao sair. */}
          <ProvedorSessao>
            <App />
          </ProvedorSessao>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
